import wx from "weixin-js-sdk";
import { handleLocalStorage } from "@/utils";

function getWxParameter(_this) {
  let mUrl = encodeURIComponent(window.location.href.split("#")[0]);
  let sendParams = { url: mUrl };
  _this
    .$http("wechath5/zh-cn/v1/wrapper/jssdk", sendParams)
    .then((res) => {
      if (!res) {
        if (_this) {
          _this.$toast("jssdk配置信息接口返回数据为空");
        }
        return;
      }
      handleLocalStorage.set("appId", res.AppId);
      handleLocalStorage.set("componentAppId", res.ComponentAppId); //授权第三方appId
      wx.config({
        debug: false,
        appId: res.AppId,
        nonceStr: res.Noncestr,
        timestamp: res.Timestamp,
        signature: res.Signature,
        jsApiList: [
          "chooseWXPay",
          "checkJsApi",
          "scanQRCode",
          "getLocation",
          "chooseImage",
          "uploadImage",
          "getLocalImgData",
          "openLocation",
          "previewImage",
          "showMenuItems",
          "hideMenuItems",
          "translateVoice",
          "hideOptionMenu",
          "showMenuItems",
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
          "onMenuShareQQ",
          "onMenuShareQZone",
          "onLocationChange",
        ],
        openTagList: ["wx-open-launch-weapp"],
      });
    })
    .catch((err) => {
      if (_this) {
        _this.$toast(err);
      }
    });
}


function jumpWXAPP(_this){
    getWxParameter(_this)
  // 3. 配置成功后的回调
    wx.ready(() => {
        console.log('config success');
        // 可选：监听用户点击跳转后的事件
        const btn = document.getElementById('launch-btn');
        btn.addEventListener('launch', (e) => {
            console.log('跳转成功', e);
        });
        btn.addEventListener('error', (e) => {
            console.log('跳转失败', e.detail);
        });
    });

}

function chooseWXPay(_this,paymentParams,SuccessCallback){
  wx.ready(()=>{
    wx.checkJsApi({
           jsApiList: ["chooseWXPay"],
            success: function (res) {
          if (res.checkResult.chooseWXPay === false) {
          _this.$toast(
            "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！"
          );
          return false;
        }
      },
    })
      wx.chooseWXPay({
          timestamp: paymentParams.timeStamp, // 支付签名时间戳
          nonceStr: paymentParams.nonceStr, // 支付签名随机串
          package: paymentParams.package, // 统一支付接口返回的prepay_id参数
          signType: paymentParams.signType || 'MD5', // 签名方式，默认为MD5
          paySign: paymentParams.paySign, // 支付签名
          // 支付成功回调
          success: function(res) {
            console.log('支付成功', res);      
            // 跳转到成功页面
            SuccessCallback(res)
          },
          // 支付取消回调
          cancel: function(res) {
            console.log('用户取消支付', res);
            SuccessCallback(res)
          },
          // 支付失败回调
          fail: function(res) {
            console.error('支付失败', res);
            SuccessCallback(res)
          },
          // 支付完成（无论成功失败都会执行）
          complete: function(res) {
            console.log('支付流程结束', res);
            SuccessCallback(res)
          }
        });


  })

} 



function chooseImage(_this,SuccessCallback){
  wx.ready(()=>{
    wx.checkJsApi({
           jsApiList: ["chooseImage"],
            success: function (res) {
          if (res.checkResult.chooseImage === false) {
          _this.$toast(
            "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！"
          );
          return false;
        }
      },
    })
   wx.chooseImage({
        count: 1,
        sourceType: ["album", "camera"],
        success: (res) => {
            wx.getLocalImgData({
      localId: res.localIds[0],
      success: function(res) {
       var localData = res.localData;
        if (localData.indexOf('data:image') !== 0) {
          localData = 'data:image/jpeg;base64,' + localData;
        }
        SuccessCallback([localData]);
      }
    });
        
    
        },
        fail: (error) => {
         _this.$toast(
           `选择失败: ${error.errMsg}`
          );
        },
        complete: () => {
          console.log("选择操作完成");
        },
      });
  })

} 

function consultMap(_this, shopLat, shopLon, storeName, shopAddress) {
  wx.ready(() => {
    wx.checkJsApi({
      jsApiList: ["openLocation"],
      success: function (res) {
        if (res.checkResult.openLocation === false) {
          _this.$toast(
            "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！"
          );
          return false;
        }
      },
    });
    wx.openLocation({
      name: storeName, // 位置名
      latitude: parseFloat(shopLat), // 纬度，浮点数，范围为90 ~ -90
      longitude: parseFloat(shopLon), // 经度，浮点数，范围为180 ~ -180
      address: shopAddress, // 地址详情说明
      scale: 12, // 地图缩放级别,整形值,范围从1~28。默认为最大
      infoUrl: "", // 在查看位置界面底部显示的超链接,可点击跳转
      success: function (res) {},
      fail: function (err) {
        _this.$toast(err.errMsg);
      },
    });
  });
}

// function WeChatShare(_this, Link, Title, ImgUrl, Desc, SuccessCallback) {
//   var params = {
//     link: Link, // 分享链接
//     title: Title, // 分享标题
//     imgUrl: ImgUrl, // 分享图标
//     desc: Desc, // 分享描述
//     success: function() {
//       if (SuccessCallback) {
//         SuccessCallback();
//       }
//     },
//     cancel: function() {
//       if (SuccessCallback) {
//         SuccessCallback();
//       }
//       _this.$toast('取消分享');
//     }
//   };

//   wx.ready(() => {
//     wx.showMenuItems({
//       menuList: [
//         'menuItem:share:qq',
//         'menuItem:share:QZone',
//         'menuItem:share:weiboApp',
//         'menuItem:share:facebook',
//         'menuItem:share:timeline',
//         'menuItem:share:appMessage'
//       ]
//     });
//     // 分享至朋友圈
//     wx.onMenuShareAppMessage(params);
//     // 分享至微信好友
//     wx.onMenuShareTimeline(params);
//     // 分享给QQ好友
//     wx.onMenuShareQQ(params);
//     // 分享至QQ空间
//     wx.onMenuShareQZone(params);
//     wx.error(function(res) {
//       // config信息验证失败会执行error函数，如签名过期导致验证失败
//       _this.$toast('config信息验证失败');
//     });
//   });
// };
function WeChatShare(_this, Link, Title, ImgUrl, Desc, SuccessCallback) {
  const params = {
    title: Title, // 分享标题
    desc: Desc, // 分享描述
    link: Link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名
    imgUrl: ImgUrl, // 分享图标
    success: function () {
      if (SuccessCallback) {
        console.log("成功分享了");
        SuccessCallback();
      }
    },
    cancel: function () {
      // if (SuccessCallback) {
      //   SuccessCallback();
      // }
      _this.$toast("取消分享");
    },
  };
  wx.ready(function () {
    //需在用户可能点击分享按钮前就先调用
    wx.showMenuItems({
      menuList: [
        "menuItem:share:qq",
        "menuItem:share:QZone",
        "menuItem:share:weiboApp",
        "menuItem:share:facebook",
        "menuItem:share:timeline",
        "menuItem:share:appMessage",
        "menuItem:profile",
      ],
    });
    // console.log(`obj打印***** 分享参数params ***** 113行 ~/jinguiProject/wxweb-vue-main/src/util/wxConfig.js  14:32:40`);
    // console.log(JSON.stringify(params, null, '\t'));
    // // 新版分享至微信好友
    // if (wx.updateAppMessageShareData) {
    //   console.log(`*****<<<  新版分享微信  115行 ~/jinguiProject/wxweb-vue-main/src/util/wxConfig.js  14:32:15`);
    //   wx.updateAppMessageShareData(params)
    // } else if (wx.onMenuShareTimeline) { // 老板分享至微信好友
    console.log(
      `*****<<<  老版分享  118行 ~/jinguiProject/wxweb-vue-main/src/util/wxConfig.js  14:32:23`
    );
    wx.onMenuShareTimeline(params);
    // 分享至朋友圈
    wx.onMenuShareAppMessage(params);
    // 分享给QQ好友
    wx.onMenuShareQQ(params);
    // 分享至QQ空间
    wx.onMenuShareQZone(params);
    // }
    // // 新版分享至朋友圈
    // if (wx.updateTimelineShareData) {
    //   console.log(`*****<<<  新版分享至朋友圈  131行 ~/jinguiProject/wxweb-vue-main/src/util/wxConfig.js  14:48:52`);
    //   wx.updateTimelineShareData(params)
    // }

    wx.error(function (res) {
      // config信息验证失败会执行error函数，如签名过期导致验证失败
      _this.$toast("config信息验证失败");
    });
  });
}

function blockingWechatSharing(_this) {
  getWxParameter(_this);
  wx.ready(() => {
    wx.hideMenuItems({
      menuList: [
        "menuItem:share:qq",
        "menuItem:share:QZone",
        "menuItem:share:weiboApp",
        "menuItem:share:facebook",
        "menuItem:share:timeline",
        "menuItem:share:appMessage",
      ],
    });
  });
}

export default {
  consultMap,
  WeChatShare,
  blockingWechatSharing,
  chooseImage,
  getWxParameter,
  chooseWXPay
};
